import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./confirm.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { getFocusTrap } from '~/modules/helpers/focusTrap';
import { ConfirmStatus, confirmStore } from '~/modules/stores/confirmStore';
class Confirm extends LightningElement {
  constructor(...args) {
    super(...args);
    this.confirmState = void 0;
  }
  renderedCallback() {
    if (!this.showConfirm) {
      return;
    }
    const container = this.confirmContainerRef;
    if (!container) {
      return;
    }
    this.focusTrap = getFocusTrap(container);
    this.focusFirstInput();
  }
  get confirmContainerRef() {
    // @ts-expect-error * Automated Type Error Fix
    return this.template.querySelector('.confirm');
  }
  get showConfirm() {
    return this.confirmState?.confirmStatus === ConfirmStatus.OPENED;
  }
  cancel() {
    confirmStore.cancel();
    this.confirmState.previousFocusedElement?.focus();
  }
  confirm() {
    confirmStore.confirm();
    this.confirmState.previousFocusedElement?.focus();
  }

  // @ts-expect-error * Automated Type Error Fix
  handleNextFocus(event) {
    const {
      focusNext
    } = this.focusTrap;
    const {
      shouldPreventDefault
    } = focusNext();
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handlePrevFocus(event) {
    const {
      focusPrevious
    } = this.focusTrap;
    const {
      shouldPreventDefault
    } = focusPrevious();
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleInputKey(event) {
    if (event.key === 'Escape') {
      this.cancel();
    }
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        this.handlePrevFocus(event);
      } else {
        this.handleNextFocus(event);
      }
    }
  }
  focusFirstInput() {
    this.focusTrap.focusFirstElement();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Confirm, {
  wire: {
    confirmState: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: confirmStore
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Confirm, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;